import { Navigate } from "react-router-dom";
import showToast from "../../Helpers/toast";
import { isAuthenticated } from "../../Helpers/authHelper";


const NotLoggedInWrapper = ({ children }) => {

  const isLoggedIn = isAuthenticated()

  if (isLoggedIn) {
    showToast({ message: "You are already Logged In!", type: "warning" })
    return <Navigate to="/modules" />; // Redirect to login if no access token
  }

  return <div>{children}</div>
};

export default NotLoggedInWrapper;
